import Vue from 'vue'
import store from '..'
import { mapGetters, createNamespacedHelpers } from 'vuex'

const { mapGetters: shopGetters } = createNamespacedHelpers('shop')

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    initList (state) {
      state.list = []
    },
    addList(state, item) {
      const index = state.list.findIndex(x => x.cartId === item.cartId)
      if (index > -1) {
        // 이미 존재하는 경우: 기존 항목 교체 (반응형 유지)
        Vue.set(state.list, item.cartId, item)
      } else {
        // 새 항목 추가
        state.list.push(item)
      }
    },
  
    delList(state, cartId) {
      // const index = state.list.findIndex(x => x.cartId === cartId)
      // if (index > -1) {
      //   // Vue.delete로 배열 요소 삭제 (반응형 유지)
      //   Vue.delete(state.list, index)
      //   localStorage.removeItem(cartId)
      // }
      state.list = state.list.filter(x => x.cartId !== cartId)
      localStorage.removeItem(cartId)
    },
    setItemQuantity (state, data) {
      const item = state.list.find(x => x.cartId === data.cartId)
      if (item) {
        const content = item.content && item.content.find(x => x.type === 'quantity')
        const price = item.price && item.price.info
        const guestTypePrice = item.guestTypePrice
        if (content) {
          content.value.quantity = data.quantity
          content.value.total = content.value.sum + content.value.price * data.quantity
        }
        if (price) {
          price.quantity = data.quantity
          price.total = price.sum + price.price * data.quantity
        }
        if (guestTypePrice) {
          guestTypePrice.quantity = data.quantity
          guestTypePrice.total = guestTypePrice.price * data.quantity
        }
        if (item.cartId.includes('shop')) {
          item.payload.quantity = data.quantity
        }
        localStorage.setItem(item.cartId, JSON.stringify(item))
      }
    },
    setItemPrice (state, data) {
      const item = state.list.find(x => x.cartId === data.cartId)
      if (item) {
        Vue.set(item, 'totalPrice', data.price)
        Vue.set(item.payload, 'totalPrice', data.price)
      }
    },
    delAmenity (state, raCode) {
      const siteId = store.state.authentication.site
      const cartId = `cart_${siteId}_amenity`
      const cartAmenity = state.list.find(x => x.cartId === cartId)
      if (cartAmenity) {
        if (cartAmenity.items.length > 0) {
          cartAmenity.items = cartAmenity.items.filter(x => x.item !== raCode)
          if (cartAmenity.content) {
            cartAmenity.content = cartAmenity.content.filter(x => x.label !== raCode)
          }
          if (cartAmenity.items.length === 0) {
            state.list = state.list.filter(x => x.cartId !== cartId)
          }
        } else {
          state.list = state.list.filter(x => x.cartId !== cartId)
        }
      }
    }
  },
  actions: {
    checkCartList ({ state, commit }, otaKey) {
      const authInfo = store.getters['authentication/getAuthInfo']
      const site = authInfo && authInfo.site
      const ota = otaKey || (authInfo && authInfo.ota)
      
      if (!localStorage.length) return

      const delStorageIds = []

      for (let i = 0; i < localStorage.length; i++) {
        const storage = localStorage.key(i)

        if (!storage || !storage.includes('cart_') || !storage.includes(site)) continue

        const cartItem = JSON.parse(localStorage.getItem(storage))
        const item = {
          ...cartItem,
          cartId: storage
        }

        if (item.cartOta && item.cartOta === ota) {
          commit('addList', item)
        } else {
          delStorageIds.push(storage)
        }
      }

      delStorageIds.forEach(storage => {
        commit('delList', storage)
      })
    }
  },
  getters: {
    getList: state => (shopPageId) => {
      const cartItems = state.list
        .filter(x => x.cartId.includes('cart_') && (shopPageId ? x.shopPageId === shopPageId : true))
        .sort((a, b) => (a.payload && a.payload.createat) > (b.payload && b.payload.createat) ? -1 : (a.payload && a.payload.createat) < (b.payload && b.payload.createat) ? 1 : 0)
      return cartItems
    },
    getCartItem: state => cartId => state.list.find(x => x.cartId === cartId),
    // 장바구니 상품을 샵프로퍼티 정보로 찾음
    getCartShopItems: state => (shopItemId, isStore) => {
      const itemProperty = store.getters['shop/getItemProperty'](shopItemId, isStore)
      const items = state.list.filter(x => x.shopItemId === shopItemId)
      const cartShopItems = items.filter(x => itemProperty && x.payload).map(x => {
        const item = x.payload
        return itemProperty && {
          shopItemId: shopItemId,
          limit: Number(itemProperty.quantity.max),
          required: Number(itemProperty.quantity.min),
          quantity: item.quantity
        }
      })
      const summarize = (list) => {
        if (!Array.isArray(list) || list.length === 0) return null
        const { shopItemId, limit, required } = list[0]
        const currentQuantity = list.reduce((sum, { quantity }) => sum + (Number(quantity) || 0), 0)
        return { shopItemId, limit, required, currentQuantity }
      }

      return summarize(cartShopItems)
    },
    // 샵아이템을 장바구니에서 찾음
    findCartShopItems: state => (catCode, shopItemId) => {
      const list = state.list
      return list.filter(item => (item.shopItemId === shopItemId) && (item.catCode === catCode)).map(item => item.payload)
    }
  }
}
